const SKIP_DEFAULT_SEARCH_PARAMS_KEY = 'tablz:skip-default-search-params';

/** Mark the next table-page landing to leave the URL without date/time/groupSize. */
export function markSkipDefaultSearchParams(): void {
	try {
		sessionStorage.setItem(SKIP_DEFAULT_SEARCH_PARAMS_KEY, '1');
	}
	catch {
		// sessionStorage may be unavailable (private mode / SSR)
	}
}

/** Returns true once if a table-event navigation asked to skip defaults on the table page. */
export function consumeSkipDefaultSearchParams(): boolean {
	try {
		const value = sessionStorage.getItem(SKIP_DEFAULT_SEARCH_PARAMS_KEY);
		if (!value) {
			return false;
		}
		sessionStorage.removeItem(SKIP_DEFAULT_SEARCH_PARAMS_KEY);
		return true;
	}
	catch {
		return false;
	}
}
